import { getRequestUrl, Request } from "../../request";
import { getURL } from "../../utils";

export const get_company_drivers = (data) => {
  return Request.get(
    getRequestUrl(getURL(`/api/corporation-pa/accounts/set-company-driver/`), data)
  );
};

export const post_company_drivers = (data) => {
  return Request.post(getURL("/api/corporation-pa/accounts/set-company-driver/"), data);
};
export const put_company_drivers = (data) => {
  return Request.put(getURL("/api/corporation-pa/accounts/set-company-driver/"), data);
};

export const export_company_drivers = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/accounts/set-company-driver`), data))
}